/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Integrate_Models_DescriptionInputs */

const en_directory_integrate_models_description = /** @type {(inputs: Directory_Integrate_Models_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review supported model categories and provider pricing information.`)
};

const zh_directory_integrate_models_description = /** @type {(inputs: Directory_Integrate_Models_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看支持的模型类别和服务商定价信息。`)
};

/**
* | output |
* | --- |
* | "Review supported model categories and provider pricing information." |
*
* @param {Directory_Integrate_Models_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_integrate_models_description = /** @type {((inputs?: Directory_Integrate_Models_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Integrate_Models_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_integrate_models_description(inputs)
	return zh_directory_integrate_models_description(inputs)
});
export { directory_integrate_models_description as "directory.integrate.models.description" }